import WidgetTypes from './enums/WidgetTypes';
import TempCache from './enums/TempCache';

export function getInitiatedBy(widgetType) {
    switch (widgetType) {
        case WidgetTypes.ExitPopup:
            return 'ExitPopup';
        case WidgetTypes.DOM:
            return 'Dom';
        case WidgetTypes.PreChat:
            return 'PreChat';
        case WidgetTypes.Bar:
            return 'Bar';
        case WidgetTypes.Tab:
            return 'Tab';
        case WidgetTypes.DropDown:
            return 'Standard';
        case WidgetTypes.Static:
            return 'Static';
        case WidgetTypes.VideoGreetInvitation:
            return 'VideoGreet';
        case WidgetTypes.PopupMessage:
            return 'PopupMessage';
        default:
            return 'Dom';
    }
}
// search the array for an item by its property
export function arrayObjectIndexOf(myArray, searchTerm, property) {
    let foundLast = -1;
    for (let i = 0, len = myArray.length; i < len; i++) {
        if (myArray[i][property].replace(TempCache.REMOVE_NON_ALPHANUMERIC, '') === searchTerm) {
            foundLast = i;
        }
    }
    return foundLast;
}
